import * as appUpdateTypes from './AppUpdateTypes';
import { getAppVersionByPlatformIdService } from 'src/services/updateApp.service';

export const getAppVersions = data => {
  return async dispatch => {
    try {
      dispatch(getAppVersionsPending());
      //const resp = await import('./getAppVersionByPlatformId.json');
      const resp = await getAppVersionByPlatformIdService(data);
      if (resp && resp.success) {
        dispatch(getAppVersionsSuccess(resp.data));
      } else {
        dispatch(getAppVersionsFailure());
      }
      return resp;
    } catch (error) {
      dispatch(getAppVersionsFailure());
    }
  };
};

const getAppVersionsPending = () => ({
  type: appUpdateTypes.GET_APP_VERSIONS_PENDING,
});

const getAppVersionsSuccess = data => ({
  type: appUpdateTypes.GET_APP_VERSIONS_SUCCESS,
  data,
});

const getAppVersionsFailure = () => ({
  type: appUpdateTypes.GET_APP_VERSIONS_FAILURE,
});

export const resetAppUpdate = () => {
  return dispatch => ({
    type: appUpdateTypes.APP_UPDATE_RESET_DATA
  });
};

export default {
  getAppVersions,
  resetAppUpdate,
};
